import type { CSSProperties } from "react";
import { CheckCircle2 } from "../icon-bank/AnimatedIcons";

interface TodoProgressGlyphProps {
  isComplete: boolean;
  active?: boolean;
  doneCount?: number;
  totalCount?: number;
}

export function TodoProgressGlyph({
  isComplete,
  active = true,
  doneCount = 0,
  totalCount = 0,
}: TodoProgressGlyphProps) {
  const safeTotal = Math.max(0, totalCount);
  const safeDone = Math.min(Math.max(0, doneCount), safeTotal);
  const progress = safeTotal > 0 ? safeDone / safeTotal : 0;
  const complete = isComplete || (safeTotal > 0 && progress >= 1);
  const radius = 7;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - progress);

  return (
    <span
      className={`fintheon-todo-progress-glyph ${
        complete ? "is-complete" : "is-pending"
      } ${active && !complete ? "is-active" : ""}`}
      style={
        {
          "--fintheon-todo-progress-offset": `${offset}`,
          "--fintheon-todo-progress-circumference": `${circumference}`,
        } as CSSProperties
      }
      aria-hidden="true"
    >
      {complete ? (
        <CheckCircle2 size={16} strokeWidth={2.25} />
      ) : (
        <svg className="fintheon-todo-progress-glyph__ring" viewBox="0 0 18 18">
          <circle className="track" cx="9" cy="9" r={radius} />
          <circle className="fill" cx="9" cy="9" r={radius} />
        </svg>
      )}
    </span>
  );
}
